export const discoveryUrl = 'https://preference.preproduction-api.immediate.co.uk/docs/v1/swagger.json';
export const environments = {
  staging: 'https://preference.staging-api.immediate.co.uk',
  preproduction: 'https://preference.preproduction-api.immediate.co.uk',
  production: 'https://preference.api.immediate.co.uk'
};
export const defaultHeaders = {
  'Content-Type': 'text/plain'
};
export default {
  discoveryUrl,
  environments,
  defaultHeaders
};